import { DOCUMENT_CATEGORIEST_TYPES, GLOBAL_TYPES } from './types';
import { DocumentCategories } from './types/rootState';

const defaultState: DocumentCategories = {
  documentCategoriesList: [],
  totalCategoriesNum: 0,
};

export default (
  state = defaultState,
  action: { type: any; key: any; $payload: any }
) => {
  switch (action.type) {
    case DOCUMENT_CATEGORIEST_TYPES.SET_DOCUMENTS_CATEGORIES_TYPES:
      return {
        ...state,
        documentCategoriesList: [...action?.$payload?.content],
        totalCategoriesNum: action?.$payload?.totalElements,
      };
    case DOCUMENT_CATEGORIEST_TYPES.ADD_DOCUMENTS_CATEGORIES_TYPES:
      return {
        ...state,
        documentCategoriesList: [
          ...state.documentCategoriesList,
          ...action?.$payload.content,
        ],
        totalCategoriesNum: action?.$payload?.totalElements,
      };
    case GLOBAL_TYPES.CLEAR_ALL_INFO_FROM_REDUCER:
      return {
        documentCategoriesList: [],
      };
    default:
      return state;
  }
};
